// Thin wrappers around `marked` (markdown → HTML) and `turndown`
// (HTML → markdown) so wizard components don't have to know which library
// is doing the conversion. Highlight.js is loaded eagerly so syntax
// highlighting works for code blocks in the report preview.

import { marked } from "marked";
import hljs from "highlight.js";
import TurndownService from "turndown";

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

const renderer = new marked.Renderer();
renderer.code = ({ text, lang }) => {
  if (lang) {
    try {
      const highlighted = hljs.highlight(text, { language: lang }).value;
      return `<pre><code class="hljs language-${lang}">${highlighted}</code></pre>`;
    } catch {
      // unknown language: fall through to auto detection
    }
  }
  try {
    const auto = hljs.highlightAuto(text).value;
    return `<pre><code class="hljs">${auto}</code></pre>`;
  } catch {
    return `<pre><code>${escapeHtml(text)}</code></pre>`;
  }
};

marked.use({ renderer });

export function markdownToHtml(md: string): string {
  if (!md) return "";
  return marked.parse(md, { async: false }) as string;
}

const turndown = new TurndownService({ headingStyle: "atx", codeBlockStyle: "fenced" });

export function htmlToMarkdown(html: string): string {
  return turndown.turndown(html || "");
}
